import { Spinner } from "reactstrap";

interface ICenterSpinnerProps {
  showLoader: boolean;
  className?: string;
}

const CenterSpinner: React.FunctionComponent<ICenterSpinnerProps> = ({
  className,
  showLoader,
}) => {
  return (
    <>
      {showLoader && (
        <div
          className={`spinner-element ${className ? className : "spinner-center"
            }`}
        >
          <img
            src={require('../assets/img/Loading_gif_new.gif')}
            style={{ height: '100px', width: '100px' }}
          />
        </div>
      )}
    </>
  );
};

export default CenterSpinner;
